import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  IQueryParam,
  TipoEnvio,
  IUsuario,
  ICategoriaEvento,
  ICodigoDispositivo,
  ICliente,
  IDispositivoAlarma,
  IActivo,
  ICreateConfigEventoUsuario,
  IUpdateConfigEventoUsuario,
  IConfigEventoUsuario,
} from 'modelos/src';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { DialogService } from '../../../../auxiliares/dialog/dialog.service';
import { HelperService } from '../../../../auxiliares/servicios/helper.service';
import { AuxiliaresModule } from '../../../../auxiliares/auxiliares.module';
import { ListadoCategoriasService } from '../../../../auxiliares/servicios/http/listado-categorias.service';
import { ConfigEventoUsuarioService } from '../../../../auxiliares/servicios/http/config-evento-usuario.service';
import { Lista2Service } from '../../../../auxiliares/servicios/lista2.service';
import { ClienteSelectorComponent } from '../../../../componentes/selectores/cliente-selector/cliente-selector.component';
import { ConfigHorariosAtencionComponent } from '../../config-horarios-atencion/config-horarios-atencion.component';
import {
  ICreateListadoCategoria,
  IListadoCategoria,
  ITipoListadoCategoria,
} from 'modelos/src/interfaces/listado-categoria';

@Component({
  imports: [
    AuxiliaresModule,
    ClienteSelectorComponent,
    ConfigHorariosAtencionComponent,
  ],
  selector: 'app-crear-editar-config-evento',
  templateUrl: './crear-editar-config-evento.component.html',
  styleUrl: './crear-editar-config-evento.component.scss',
})
export class CrearEditarConfigEventoComponent implements OnInit, OnDestroy {
  data = inject(MAT_DIALOG_DATA);
  helper = inject(HelperService);
  private service = inject(ConfigEventoUsuarioService);
  private listadoCategoriasService = inject(ListadoCategoriasService);
  dialog = inject(MatDialog);
  private dialogService = inject(DialogService);
  private lista2 = inject(Lista2Service);

  //DEMAS
  public creandoNuevoTag?: boolean = false;
  public id?: string;
  public idTracker?: string;
  public idAlarma?: string;
  public dispositivo?: IDispositivoAlarma | IActivo;
  public form?: FormGroup;
  public title?: string;
  public editar: boolean = false;
  public configEvento?: IConfigEventoUsuario;
  public usuarios: IUsuario[] = [];
  public codigosEvento: ICodigoDispositivo[] = [];
  public categoriasEvento: ICategoriaEvento[] = [];
  public listadoCategorias: IListadoCategoria[] = [];
  public clienteDispositivo: ICliente;
  public loading: boolean = false;
  public mostrarZona: boolean = false;
  //Subs
  public categorias$: Subscription;
  public listadoCategorias$: Subscription;
  public trackers$: Subscription;
  public alarmas$: Subscription;
  public usuarios$?: Subscription;

  public tiposEnvio: TipoEnvio[] = [
    // 'SMS',
    // 'WhatsApp',
    // 'Llamada',
    'Notificacion Push',
  ];

  private query: IQueryParam = {};

  get configZona() {
    return this.form?.get('configZona') as FormGroup;
  }

  get idCliente() {
    return this.clienteDispositivo?._id;
  }

  private createForm() {
    this.form = new FormGroup({
      idListadoCategoria: new FormControl(
        this.configEvento?.idCategoriaEvento,
        Validators.required,
      ),
      idCategoriaEvento: new FormControl(this.configEvento?.idCategoriaEvento),
      notificar: new FormControl(this.configEvento?.notificar || false),
      codigoReportado: new FormControl(this.configEvento?.codigoReportado),
      noDerivar: new FormControl(this.configEvento?.noDerivar || false),
      idEntidad: new FormControl(this.configEvento?.idEntidad || this.id),
      atender: new FormControl(this.configEvento?.atender || false),
      idsClientesQuePuedenAtender: new FormControl(
        this.configEvento?.idsClientesQuePuedenAtender ||
          this.dispositivo?.idsClientesQuePuedenAtender,
      ),
      configHorariosAtencion: new FormControl(
        this.configEvento?.configHorariosAtencion ||
          this.dispositivo?.configHorariosAtencion,
      ),
      idsUsuarios: new FormControl(this.configEvento?.idsUsuarios),
      configZona: new FormGroup({
        particion: new FormControl(this.configEvento?.configZona?.particion),
        zona: new FormControl(this.configEvento?.configZona?.zona),
      }),
    });
  }
  public async listarListadoCategoria(): Promise<void> {
    const tipo: ITipoListadoCategoria = this.idAlarma
      ? 'Evento-Alarma'
      : 'Evento-Tracker';
    const query: IQueryParam = { filter: JSON.stringify({ categoria: tipo }) };
    this.listadoCategorias$?.unsubscribe();
    this.listadoCategorias$ = this.lista2
      .listadoCategorias(query, 30)
      .subscribe((data) => {
        this.listadoCategorias = data.datos;
      });
  }
  private async listarUsuarios(): Promise<void> {
    const query: IQueryParam = {
      select: 'usuario datosPersonales.telefono permisos',
      sort: 'usuario',
    };
    this.usuarios$?.unsubscribe();
    this.usuarios$ = this.lista2.usuarios(query, 30).subscribe((data) => {
      this.usuarios = data.datos;
    });
  }

  public async listarCategorias(): Promise<void> {
    this.categorias$?.unsubscribe();
    this.categorias$ = this.lista2
      .categoriaEventos(this.query, 30)
      .subscribe((data) => {
        this.categoriasEvento = data.datos;
      });
  }

  //
  public async onSubmit() {
    this.loading = true;
    const res = await this.dialogService.confirm(
      `Confirmá la acción`,
      `¿Querés ${this.title.toLowerCase()}?`,
    );
    if (!res) return;
    try {
      const data = this.getData();
      if (this.editar) {
        // Update
        await this.service.update(this.id, data);
        this.helper.notifSuccess('Código Personalizado actualizado');
        this.dialog.closeAll();
      } else {
        // // Create
        this.idAlarma
          ? (data.idEntidad = this.idAlarma)
          : (data.idEntidad = this.idTracker);
        await this.service.create(data);
        this.helper.notifSuccess('Código Personalizado creado');
        this.dialog.closeAll();
        this.loading = false;
      }
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
      this.loading = false;
    }
  }

  public async addTag(t: string) {
    if (!this.creandoNuevoTag) {
      this.creandoNuevoTag = true;
      const listadoCategoria: ICreateListadoCategoria = {
        nombre: t,
        categoria: this.idAlarma ? 'Evento-Alarma' : 'Evento-Tracker',
      };
      try {
        const res =
          await this.listadoCategoriasService.create(listadoCategoria);
        this.form.patchValue({ idListadoCategoria: res._id });
        this.creandoNuevoTag = false;
      } catch {
        this.creandoNuevoTag = false;
      }
    }
  }

  // Buscar usuario

  public searchUsuario = (term: string, item: IUsuario) => {
    if (item.usuario?.toLowerCase().includes(term.toLowerCase())) return true;
    if (
      item.datosPersonales?.nombre?.toLowerCase().includes(term.toLowerCase())
    )
      return true;
    if (
      item.datosPersonales?.telefono?.toLowerCase().includes(term.toLowerCase())
    )
      return true;
    if (item.datosPersonales?.email?.toLowerCase().includes(term.toLowerCase()))
      return true;
    return false;
  };

  public searchCodigo = (term: string, item: ICodigoDispositivo) => {
    if (item.codigo?.toLowerCase().includes(term.toLowerCase())) return true;
    if (item.descripcion?.toLowerCase().includes(term.toLowerCase()))
      return true;
    return false;
  };

  public setCategoria(c: ICategoriaEvento) {
    if (c) {
      this.form.patchValue({ notificar: c.notificar });
      this.form.patchValue({ noDerivar: c.noDerivar });
      this.form.patchValue({ atender: c.atender });
    } else {
      this.form.patchValue({ notificar: false });
      this.form.patchValue({ noDerivar: false });
      this.form.patchValue({ atender: false });
    }
  }

  public setCodigo(cod: ICodigoDispositivo) {
    if (cod) {
      this.form.patchValue({ idCategoriaEvento: cod.idCategoriaEvento });
      this.setCategoria(
        this.categoriasEvento.find((c) => c._id === cod.idCategoriaEvento),
      );

      if (cod.mostrarZona) this.mostrarZona = cod.mostrarZona;
      else this.mostrarZona = cod.mostrarZona;
    } else {
      this.form.patchValue({ idCategoriaEvento: null });
      this.setCategoria(null);
      this.mostrarZona = false;
    }
  }

  public getData(): ICreateConfigEventoUsuario | IUpdateConfigEventoUsuario {
    const data: ICreateConfigEventoUsuario | IUpdateConfigEventoUsuario =
      this.form?.value;
    return data;
  }

  async ngOnInit() {
    if (this.data?.activo) {
      this.idTracker = this.data?.activo?.idTracker;
      this.dispositivo = this.data?.activo;
      this.clienteDispositivo = this.data?.activo?.cliente;
      this.codigosEvento = this.data?.activo?.tracker?.modelo?.codigos?.codigos;
    }
    if (this.data?.alarma) {
      this.idAlarma = this.data?.alarma?._id;
      this.dispositivo = this.data?.alarma;
      this.clienteDispositivo = this.data?.alarma?.cliente;
      this.codigosEvento = this.data?.alarma?.modelo?.codigos?.codigos;
    }
    if (this.data?.configEvento) {
      this.id = this.data.configEvento.id;
      this.editar = true;
      this.configEvento = this.data?.configEvento;
      this.mostrarZona =
        this.configEvento?.configZona?.zona ||
        this.configEvento?.configZona?.particion
          ? true
          : false;
    } else {
      this.editar = false;
    }
    this.title = this.editar
      ? 'Editar Código Personalizado'
      : 'Crear Código Personalizado';
    this.createForm();
    await Promise.all([
      this.listarListadoCategoria(),
      this.listarUsuarios(),
      this.listarCategorias(),
    ]);
  }

  public async ngOnDestroy(): Promise<void> {
    this.categorias$?.unsubscribe();
    this.listadoCategorias$?.unsubscribe();
    this.usuarios$?.unsubscribe();
    this.trackers$?.unsubscribe();
  }
}
